import React from "react";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Chip,
  useMediaQuery,
  useTheme,
  Paper,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import arrow_down from "../../images/table/Arrow_down.svg";
export default function VehiclesSection({
  routeData,
  vehicles,
  onVehicleChange,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const vehicleList = Array.isArray(vehicles)
    ? vehicles
    : vehicles.vehicles || [];

  const handleVehicleSelectionChange = (e) => {
    const selectedVehicleIds = e.target.value;
    const selectedVehicles = vehicleList.filter((vehicle) =>
      selectedVehicleIds.includes(vehicle.id)
    );
    // Pass the entire array instead of calling onVehicleChange multiple times
    if (routeData.selectedVehicles) {
      onVehicleChange(selectedVehicles);
    }
  };
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "10px",
        border: "1px solid #A5DCF3",
        padding: "12px",
        gap: "16px",
        boxShadow: "-2px 2px 5px 0px #00000040",
        display: "flex",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          width: isSmallScreen ? "100%" : "calc(100% - 610px)",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "16px",
            height: "100%",
          }}
        >
          <Box>
            <Box
              display="flex"
              flexDirection={isExtraSmallScreen ? "column" : "row"}
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              sx={{
                background: "#647490",
                boxShadow: "0px 2px 5px 0px #00000040",
                padding: "10px 16px",
                gap: isExtraSmallScreen ? 2 : 0,
                borderRadius: 4,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 500,
                  fontSize: "20px",
                  marginBottom: isExtraSmallScreen ? "10px" : 0,
                  textAlign: isExtraSmallScreen ? "center" : "left",
                  width: isExtraSmallScreen ? "100%" : "auto",
                }}
              >
                {t("Vehicles on this Route")}
              </Typography>
            </Box>
            <FormControl fullWidth>
              <Select
                displayEmpty
                fullWidth
                IconComponent={() => (
                  <img
                    src={arrow_down}
                    alt="arrow down"
                    style={{ width: 20, height: 20, marginRight: 8 }}
                  />
                )}
                labelId="vehicles-multiple-checkbox-label"
                id="vehicles-multiple-checkbox"
                size="small"
                multiple
                value={routeData.selectedVehicles.map((v) => v.id)}
                onChange={handleVehicleSelectionChange}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return (
                      <span style={{ color: "#183059", fontWeight: 500 }}>
                        {t("Select Vehicles")}
                      </span>
                    );
                  }
                  return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((id) => (
                        <Chip
                          key={id}
                          label={vehicleList.find((v) => v.id === id)?.name}
                          size="small"
                        />
                      ))}
                    </Box>
                  );
                }}
                sx={{
                  backgroundColor: "#fff",
                  "& .MuiSelect-select": {
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    color: "#183059",
                    display: "flex",
                    flexWrap: "wrap",
                    minHeight: "30px",
                    alignItems: "center",
                    padding: "8px 14px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#B7BFCC",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #B7BFCC",
                  },
                  minHeight: "40px",
                }}
                MenuProps={{
                  disableScrollLock: true,
                  zIndex: 0,
                  PaperProps: {
                    style: {
                      maxHeight: 204,
                      width: 250,
                    },
                  },
                }}
              >
                {vehicleList.map((vehicle) => (
                  <MenuItem key={vehicle.id} value={vehicle.id}>
                    <Checkbox
                      checked={
                        routeData.selectedVehicles
                          .map((v) => v.id)
                          .indexOf(vehicle.id) > -1
                      }
                      sx={{
                        color: "#20A8E0",
                        "&.Mui-checked": {
                          color: "#20A8E0",
                        },
                      }}
                    />
                    <ListItemText primary={vehicle.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box
            sx={{
              display: "flex",
              borderRadius: "8px",
              padding: "12px",
              justifyContent: "space-between",
              border: "1px solid #B7BFCC",
              flexDirection: isSmallScreen ? "column" : "row",
              alignItems: isSmallScreen ? "stretch" : "center",
              gap: isSmallScreen ? 1 : 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#183059",
                fontSize: "14px",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {t("No vehicles to select?")}
            </Typography>
            <Button
              variant="contained"
              onClick={() =>
                navigate("/vehicle/add")
              }
              sx={{
                width: "auto",
                textTransform: "none",
                height: "35px",
                whiteSpace: "nowrap",
                borderRadius: 2,
                fontSize: "16px",
                fontWeight: 600,
                padding: "8px 18px",
                color: "#1F242E",
                backgroundColor: "#F9E719",
                border: "1px solid #414958",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "#F5E016",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  transform: "translateY(-1px)",
                  border: "1px solid #2C3441",
                },
                "&:active": {
                  transform: "translateY(0)",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                },
                "&:focus": {
                  outline: "2px solid #F9E719",
                  outlineOffset: "2px",
                },
              }}
            >
              {t("+ Create Vehicles")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
